/* BORROWED. — free shipping meter at the top of the cart drawer */
(function () {
  var THRESHOLD = 4997; /* pence, matches the £49.97 free delivery rate */

  function money(p) {
    return '£' + (p / 100).toFixed(2);
  }

  function build() {
    var el = document.createElement('div');
    el.className = 'brwd-ship-meter';
    el.innerHTML =
      '<span class="brwd-ship-meter__label"></span>' +
      '<div class="brwd-ship-meter__track"><div class="brwd-ship-meter__fill"></div></div>';
    return el;
  }

  function render(total) {
    var inner = document.querySelector('.cart-drawer__inner');
    if (!inner) return;
    var meter = inner.querySelector('.brwd-ship-meter');
    if (!meter) {
      meter = build();
      var header = inner.querySelector('.theme-drawer__header');
      if (header && header.nextSibling) inner.insertBefore(meter, header.nextSibling);
      else inner.insertBefore(meter, inner.firstChild);
    }
    var label = meter.querySelector('.brwd-ship-meter__label');
    var fill = meter.querySelector('.brwd-ship-meter__fill');
    var remaining = THRESHOLD - total;
    if (total <= 0) {
      label.textContent = 'Free UK delivery over ' + money(THRESHOLD);
      label.classList.remove('is-hit');
      fill.style.width = '0%';
      return;
    }
    if (remaining > 0) {
      label.innerHTML = 'You are <b>' + money(remaining) + '</b> away from free UK delivery';
      label.classList.remove('is-hit');
    } else {
      label.textContent = 'Free UK delivery unlocked';
      label.classList.add('is-hit');
    }
    fill.style.width = Math.min(100, (total / THRESHOLD) * 100).toFixed(1) + '%';
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c.total_price); })
      .catch(function () {});
  }

  document.addEventListener('shopify:cart:lines-update', refresh);
  document.addEventListener('shopify:cart:discount-update', refresh);

  /* the drawer markup is re-rendered on open, so re-inject then too */
  var obs = new MutationObserver(function () {
    var inner = document.querySelector('.cart-drawer__inner');
    if (inner && !inner.querySelector('.brwd-ship-meter')) refresh();
  });

  function start() {
    obs.observe(document.body, { childList: true, subtree: true });
    refresh();
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
